import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthProvider.js';
import { signOut } from '../../auth/client.js';

export function UserMenu() {
  const { t } = useTranslation('auth');
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-slate-600">{user.name ?? user.email}</span>
      <button
        type="button"
        onClick={() => {
          void signOut().then(() => {
            window.location.href = '/login';
          });
        }}
        className="rounded border px-2 py-1 text-xs hover:bg-slate-100"
      >
        {t('logout')}
      </button>
    </div>
  );
}
